export default class GreyscaleSliderHover {
	constructor() {
		const swipers = document.querySelectorAll('.image-swiper');

		if (!swipers.length) return;

		swipers.forEach((swiper) => {
			const teases = swiper.querySelectorAll('[data-company-tease]');

			teases.forEach((tease) => {
				tease.addEventListener('mouseenter', () => {
					teases.forEach((t) => {
						if (t !== tease) t.classList.add('is-dimmed');
					});
				});

				tease.addEventListener('mouseleave', () => {
					teases.forEach((t) => t.classList.remove('is-dimmed'));
				});
			});
		});
	}
}